import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import routes from '@utils/routes';
import { MsalProvider } from '@azure/msal-react';

const MicrosoftSSOProvider = ({ children }: { children: React.ReactNode }) => {
  const msalConfig = {
    auth: {
      clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID as string,
      authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_AZURE_TENANT_ID}`,
      redirectUri: `${window.location.origin}${routes.microsoft.path}`,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'sessionStorage', // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  };

  const msalInstance = new PublicClientApplication(msalConfig);

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default MicrosoftSSOProvider;
